// This file is generated by scripts/write-build-info.mjs.
export const buildInfo = {
  version: '26.11.04-2c3b313',
  hash: '2c3b313',
  generatedAt: '2026-11-04T13:46:42.071Z',
} as const;
